var faqManager = function () {
    var faqCategoriesListing = $('.faq .icons-tab-areas.categories-listing');
    var faqQuestionsListing = $('.faq .icons-tab-areas.questions-listing');
    var tabContents = $('.faq .icons-tab-areas .tab-content');
    function init() {

        $(document).ready(function () {
            if(faqCategoriesListing.length){
                trackCategoriesClick();
            }

            if(faqQuestionsListing.length){
                trackAccordionsClick();
            }

            if (faqQuestionsListing.length>0 && $('.collapse.show.scrollToQuestion', faqQuestionsListing)) {
                var heightToRemove = $(".nav-main").outerHeight() + $('.nav-top').outerHeight() + $('breadcrumb-container').outerHeight();
                var questionToScroll = $('.collapse.show.scrollToQuestion', faqQuestionsListing).closest('.accordion-single-row');
                if (questionToScroll.length>0){
                    $('html, body').stop().animate({
                        scrollTop: (questionToScroll.offset().top - heightToRemove)
                    }, 1500);
                }
            }
        });

        $(window).on('shown.bs.tab', function () {
            if (faqCategoriesListing.length>0){
                $('.nav-link', faqCategoriesListing).each(function () {
                    var buttonIcon = $(this).find('.button-icon');
                    if ($(this).hasClass('active')){
                        buttonIcon.attr('src', buttonIcon.data('active-icon'));
                    }else{
                        buttonIcon.attr('src', buttonIcon.data('inactive-icon'));
                    }
                });
            }
        });
    }

    //track faq categories click
    function trackCategoriesClick(){
        faqCategoriesListing.find(".categories-place .tab-pane a").on("click", function(){
            var categoryClicked = $(this).find("p").text().trim();
            var tabOpend = $(this).closest(faqCategoriesListing).find(".nav-buttons-container .nav-pills .nav-item button.nav-link.active").text().trim();
            manageGTM.trackFaqClick(categoryClicked, tabOpend);
        });
    }

    //track faq accordions click
    function trackAccordionsClick(){
        var pageCategory = faqQuestionsListing.find(".main-title h2").text().trim();
        faqQuestionsListing.find(".faq-list-place .accordion .accordion-single-row .header").on("click", function(){
            if($(this).find("button.collapsed").length){
                var accordionOpend = $(this).find(".text").text().trim();
                manageGTM.trackFaqClick(accordionOpend, pageCategory);
            }
        });
    }

    return {init:init};
}(jQuery);